import { StyledInstagramPost as InstagramPost } from '../../../components/InstagramPost';

export const mapInstagramPlaceholderToInstagramComponent = matchedElem => {
  const instagramUrl = matchedElem.dataset.href;

  return (
    <InstagramPost url={instagramUrl} />
  );
};
